module.exports = __webpack_public_path__ + "img/satisfied.a4f8089.svg";